module.exports = __webpack_public_path__ + "media/images/soar/advantages_group-897df223502ec9b82b0929d37b6d5b74.png";